import { enableProdMode, isDevMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { defineCustomElements } from '@ionic/pwa-elements/loader';

import { environment } from '@env/environment';
import { browserTracingIntegration, init as sentryAngularInit } from '@sentry/angular';
import * as SentryCapacitor from '@sentry/capacitor';
import 'barcode-detector/polyfill';
import 'hammerjs';

import { AppModule } from '@app/app.module';

import { OtaUpdatesService } from '@pages/other/ota-updates/services/ota-updates.service';

import packagejson from '../package.json';

OtaUpdatesService.notifyAppReady();

if (environment.production) {
  enableProdMode();
}

const sentryDsn = atob(environment.sentry);
let platform = 'android';
if (environment.isMIB) {
  platform = 'ios';
} else if (environment.pwa.enabled) {
  platform = 'pwa';
}
const version = packagejson.version;

SentryCapacitor.init(
  {
    dsn: sentryDsn,
    release: `${platform}@${version}`,
    tracesSampleRate: 0,
    integrations: [browserTracingIntegration()],
    // Set "tracePropagationTargets" to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: ['localhost']
  },
  sentryAngularInit
);

// Disable console methods in production environment
if (!isDevMode()) {
  const silentMethods = ['log', 'debug', 'info', 'warn'] as const;
  silentMethods.forEach((method) => {
    (window.console as any)[method] = () => {};
  });
}

// Call the element loader before the bootstrapModule/bootstrapApplication call
defineCustomElements(window);

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => {
    // eslint-disable-next-line no-console
    console.error(err);
  });
